// @Version: 1.0.0
import { Component } from '@angular/core';
import { TRANSLATE_PATH } from '../../../shared.model';

@Component({
  selector: 'app-action-logo',
  templateUrl: './action-logo.component.html',
  standalone: false
})
export class ActionLogoComponent {
   public TRANSLATE_PATH: typeof TRANSLATE_PATH = TRANSLATE_PATH;
}
